import { render, staticRenderFns } from "./ExtDialog.vue?vue&type=template&id=22dc5f6f"
import script from "./ExtDialog.vue?vue&type=script&lang=js"
export * from "./ExtDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports